import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ClosableModalWithErrorResponseModel } from '../../base/closable-modal-with-error-response-model';
import { AddSubtopicModalPayload, BackgroundInfoSubTopic, AddSubtopicErrorResponse } from '../../../models';

import { ModalService } from '../../../modules/modal';

import { NotificationService, BackgroundInfoService } from '../../../services';
import { TranslationConstants } from '../../../constants/translation';

@Component({
  selector: 'add-subtopic',
  templateUrl: './add-subtopic-modal.component.html',
})
export class AddSubtopicModalComponent extends ClosableModalWithErrorResponseModel<AddSubtopicErrorResponse>
  implements OnInit, OnDestroy {
  data: AddSubtopicModalPayload;
  newSubtopic = new BackgroundInfoSubTopic();
  confirmationModalTitle = TranslationConstants.CLOSE_ADD_NEW_SUBTOPIC;

  constructor(
    protected modalService: ModalService,
    protected notificationService: NotificationService,
    private _backgroundInfoService: BackgroundInfoService,
    private _translate: TranslateService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new AddSubtopicErrorResponse();
  }

  ngOnInit(): void {
    this.listenForErrorMessages();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getUseCaseKey(): string {
    return this._backgroundInfoService.getTranslationKeyByBackInfoType(this.data.useCase);
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this.newSubtopic.jurisdictionId = this.data.activeJurisdiction && this.data.activeJurisdiction.jurisdiction && this.data.activeJurisdiction.jurisdiction.countryId || undefined;

    if (this.data.activeTopic) {
      this.newSubtopic.topicName = this.data.activeTopic.name;
      this.newSubtopic.topicId = this.data.activeTopic.topicId;
    }

    this._backgroundInfoService.addNewSubtopic(this.data.objectId, this.data.useCase, this.newSubtopic)
      .subscribe(() => {
        this.closeAllModals();
        this.success();
      }
      );
  }

  getJurisdictionName(): string {
    return (this.data.activeTopic && this.data.activeTopic.country && this.data.activeTopic.country.isoCode) || this._translate.instant('global.all');
  }
}
